import { createContext } from 'react';
import { TomTomApiResult } from '../../types/TomTom/TomTomApiResult';

export type Booking = {
  name: string;
  phoneNumber: string;
  destination?: TomTomApiResult;
  passengers: number;
  email: string;
};

export const initialBookingState: Booking = {
  name: '',
  phoneNumber: '',
  destination: undefined,
  passengers: 0,
  email: '',
};

const BookingContext = createContext<{
  booking: Booking;
  setBooking: React.Dispatch<React.SetStateAction<Booking>> | null;
}>({ booking: initialBookingState, setBooking: null });

export default BookingContext;
